import { isEmpty, mapValues } from 'lodash';
import { AssetLibrary } from 'src/app/story/models/story.model';
import { match } from 'minimatch';

interface NamespaceMap {
  [oldStateId: string]: string; // newStateId;
}

export namespace RenamespaceUtils {
  export interface PropertiesMap {
    showObjects?: {};
    selectObjects?: {};
    pickThroughObjects?: {};
    colorRecipeObjects?: {};
    synchronization?: {};
  }


  /**
   * Tries to replace a term in `value` with a new term.
   * e.g. brain-root, {brain: drain} ---> drain-root
   */
  export function renamespaceValue(value: string, namespaceMap: NamespaceMap) {
    const entries = Object.entries(namespaceMap);
    
    // ensure that longer matchKeys are tested first
    // otherwise, keys that are a substring of another key renamespace incorrectly.
    entries.sort((a, b) => {
      if (a[0].length === b[0].length) {
        return 0;
      }

      if (a[0].length < b[0].length) {
        return 1;
      }

      return -1;
    });

    return entries.reduce((acc, [matchKey, replaceString]) => {
        if (acc.startsWith(matchKey)) {
          const matchRegex = new RegExp(`^${matchKey}`);
          acc = acc.replace(matchRegex, replaceString);
        }
        return acc;
      }, value || '');
  }

  /**
   * Convenient way to call renamespaceValue if given an object 
   * with multiple keys that need renamespacing.
   */
  export function renamespaceKeys(
    entry: { [key: string]: any },
    namespaceMap: NamespaceMap
  ) {
    // Iterate through key value pairs
    return Object.entries(entry).reduce((result, [sourceKey, sourceValue]) => {
      const newKey = renamespaceValue(sourceKey, namespaceMap);
      result[newKey] = sourceValue;
      return result;
    }, {});
  }

  export function renamespaceAssetLibrary(
    assetLibrary: AssetLibrary,
    namespaceMap: NamespaceMap,
    replaceObjectId: boolean
  ) {
    
    if (!replaceObjectId) {
      return assetLibrary;
    }

    const tweens = assetLibrary.tweens.map(tween => renamespaceValue(tween, namespaceMap));
    const reflections = assetLibrary.reflections.map(refl => renamespaceValue(refl, namespaceMap));

    return {
      ...assetLibrary,
      tweens,
      reflections
    };
  }

  export function renamespaceReflections(
    reflections: {},
    namespaceMap: NamespaceMap,
    replaceObjectId: boolean
  ) {
    if (!replaceObjectId) {
      return reflections;
    }
  
    return mapValues(reflections, refl => renamespaceValue(refl, namespaceMap));
  }
}
